module.exports = __webpack_public_path__ + "img/ms_my.18880457.png";